
    import { initPwaOffline } from "/js/pwa-offline.js";
    initPwaOffline();
  